import { c as _c } from "react/compiler-runtime";
import './nav-bag.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { getPublicConfig } from '@sola/config/lib/getters.ts';
export const NavBag: React.FC = () => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["priority"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    actions: t1,
    cart,
    isReady: cartIsReady
  } = useCart("actions", "cart", "isReady");
  const {
    getCart
  } = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getPublicConfig();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    NEXT_PUBLIC_BASE_URL_CHECKOUT: checkoutBaseUrl
  } = t2;
  let t3;
  if ($[2] !== getCart) {
    t3 = () => {
      getCart();
    };
    $[2] = getCart;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  const count = cartIsReady && cart?.items?.length;
  const displayCount = count && count > 10 ? "9+" : count;
  const t5 = cart?.checkoutUrl || checkoutBaseUrl;
  let t6;
  if ($[5] !== t) {
    t6 = t("header.cart");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t("header.cart");
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArkIcon iconName="shopping-bag-02" className="NavBag__icon" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== displayCount) {
    t9 = displayCount ? <span className="NavBag__count label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">{displayCount}</span> : null;
    $[10] = displayCount;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t9) {
    t10 = <Link className="NavBag flex p-comfy-xs relative" href={t5} title={t6} aria-label={t7}>{t8}{t9}</Link>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};